declare global {
    interface Window {
        tmaDebug: boolean
        tmaDebugToggle: () => void
    }
}

window.tmaDebugToggle = () => {
    window.tmaDebug = !window.tmaDebug
}

window.tmaDebug = process.env.NODE_ENV === "development"

export function debug(...args: unknown[]) {
    if (window.tmaDebug) {
        console.debug(...args)
    }
}
